import React, { useEffect, useState } from "react";
import { TimePicker, } from "antd";
import "./steps.css";
import Hexapi from "../../../utility/HexAPI/Hexapi";
import TooltipButton from "../../../components/tooltip/Popover";

export default function Step2({ userid, formData = {}, setFormData = () => {} ,meetingid}) {

const [pendinglist,setpendinglist]=useState([])
const handleTimeChange = (time) => {
  setFormData({
    ...formData,
    meetingTime: time || null,  
  });
};

  const getPendingListData = async () => {
    const today = new Date();

const dayId = 
  String(today.getDate()).padStart(2, '0') +
  String(today.getMonth() + 1).padStart(2, '0') +
  String(today.getFullYear()).slice(-2);

const CurMeetingID = meetingid == (undefined || null || "" ) ? -1 : meetingid

    try {
      const obj = {
        query:`HRApp_Droid_Proc_AddMeeting_PendingMeeting_GetList @UserID = '{0}' , @DayID='{1}',@CurMeetingID='{2}'`,
        queryArr: [`${userid}`,`${dayId}`,`${CurMeetingID}`],
      };
      const resp = await Hexapi(obj);
      console.log(resp,"resp")
      if(resp && resp?.pendingmeetings){
        setpendinglist(resp?.pendingmeetings)
      }else{
        setpendinglist([])
      }
      console.log(resp, "Pending Meetings");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userid) {
      getPendingListData();
    }
  }, [userid]);

  return (
    <div className="step2-container">

      <div className="top-section">
        <TimePicker
  style={{ width: "100%", height: "40px" }}
  use12Hours
  format="hh:mm A"
  value={formData.meetingTime || null}
  onChange={handleTimeChange}
  minuteStep={5}
/>
      </div>
      <div className="bottom-section">
     
     <div style={{fontWeight:"500" , marginBottom:"20px"}}>
      Your Pending Meetings <span><TooltipButton fieldName={"MeetingPending"}/></span>
      </div>
      {
        pendinglist.length > 0 ? pendinglist.map((res,index)=>{
          return(
            <div>
              {index}
              </div>
          )
        }) :  <p style={{color:"orange"}}>No pending meetings!</p>
      }
        
    
      </div>
    </div>
  );
}